/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iframe_Remote_Media_Loading_StatusInputs */



/**
* | output |
* | --- |
* | "Loading media..." |
*
* @param {Iframe_Remote_Media_Loading_StatusInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const iframe_remote_media_loading_status = /** @type {((inputs?: Iframe_Remote_Media_Loading_StatusInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iframe_Remote_Media_Loading_StatusInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Chargement des medias...")
	if (locale === "de") return /** @type {LocalizedString} */ ("Medien werden geladen...")
	if (locale === "it") return /** @type {LocalizedString} */ ("Caricamento del contenuto multimediale...")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Загрузка медиафайлов...")
	if (locale === "es") return /** @type {LocalizedString} */ ("Cargando medios...")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("正在加载媒体……")
	if (locale === "ja") return /** @type {LocalizedString} */ ("メディアを読み込んでいます...")
	if (locale === "hi") return /** @type {LocalizedString} */ ("मीडिया लोड हो रहा है...")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Carregando mídia...")
	return /** @type {LocalizedString} */ ("Loading media...")
});